import React from 'react';
import Fade from 'react-reveal/Fade';

const IconBriefcase = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>
);
const IconHandshake = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 18l-2-1-2 3 3 4 4-4-3-2z"></path><path d="M4.65 15.54l1.22-5.03 5.02-1.22 1.05 4.31-4.3 1.05-2.99.89z"></path><path d="M12 12l8-2 2 5-8 2-2-5z"></path></svg>
);
const IconConstruction = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="6" width="20" height="12" rx="2"></rect><path d="M12 12V6"></path><path d="M17 12V6"></path><path d="M7 12V6"></path><path d="M2 12h20"></path></svg>
);
const IconSmartphone = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line></svg>
);
const IconGlobe = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
);

const differences = [
  {
    title: "The Full Financial Life",
    desc: "WayaBank is built for the full financial life, not just the transaction. Bank, borrow, pay, earn, and grow, all in one place.",
    icon: <IconBriefcase />
  },
  {
    title: "Personal & Business, Unified",
    desc: "Unlike most Nigerian digital banks, WayaBank gives you personal and business banking in one place — with features like bulk transfers, USSD without internet, multi-account types, POS, invoicing, email-to-bank transfers, and a Refer & Win rewards programme.",
    icon: <IconHandshake />
  },
  {
    title: "Built for Builders",
    desc: "Built for more than spending. WayaBank is for the people who are building something, at every scale, in every market.",
    icon: <IconConstruction />
  },
  {
    title: "The Bank That Comes To You",
    desc: "No branch, no queue, no appointment. Open your account in minutes, from anywhere.",
    icon: <IconSmartphone />
  },
  {
    title: "Building For Everyone",
    desc: "And unlike any other fintech in Nigeria, WayaBank is also building for Mama Bisi. The tomato seller, the mama put owner, the market trader who has never been inside a bank branch and deserves one anyway. That is a customer every other product is ignoring. We are not.",
    icon: <IconGlobe />
  }
];

export default function CompetitiveSection() {
  return (
    <section className="waya-diff-section" style={{ padding: '100px 6%', background: '#ffffff', borderTop: '1px solid #f0f0f0' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <Fade bottom>
          <div style={{ textAlign: 'center', marginBottom: '64px' }}>
            <span className="waya-eyebrow-main" style={{ display: 'inline-block', background: 'var(--waya-primary-light)', padding: '6px 16px', borderRadius: '100px', color: 'var(--waya-primary)', fontWeight: '600', fontSize: '13px', marginBottom: '16px' }}>The WayaBank Difference</span>
            <h2 className="waya-section-heading">Why WayaBank Stands Out</h2>
            <p className="waya-section-subline" style={{ maxWidth: '600px', margin: '0 auto' }}>
              Here is why we are different.
            </p>
          </div>
        </Fade>

        <div className="waya-diff-grid">
          {differences.map((diff, index) => (
            <Fade bottom delay={index * 100} key={index}>
              <div className="waya-diff-card-modern">
                <div className="waya-diff-icon" style={{ color: 'var(--waya-primary)', marginBottom: '20px' }}>{diff.icon}</div>
                <h3 className="waya-diff-title">{diff.title}</h3>
                <p className="waya-diff-desc">{diff.desc}</p>
              </div>
            </Fade>
          ))}
        </div>
      </div>
    </section>
  );
}
